import React, { createContext, useContext, useState, useEffect } from 'react';
import instance from '../../services/services';
import { FOOTER_DATA_URL } from '../../utils/urls';

const FooterContext = createContext();

export const FooterProvider = ({ children }) => {
    const [footerData, setFooterData] = useState(null);
    const [allianceLogoImage, setAllianceLogoImage] = useState(null);
    // 기존 Footer.js의 로직 그대로 가져오기
    useEffect(() => {
        const fetchFooterData = async () => {
        try {
            const response = await instance.post(FOOTER_DATA_URL);
            setFooterData(response.data.data.data);
            setAllianceLogoImage(response.data.data.allianceLogoImage);
        } catch (error) {
            console.error('Footer 데이터 가져오기 실패:', error);
        }
        };
        fetchFooterData();
    }, []);

    return (
        <FooterContext.Provider value={{ footerData, allianceLogoImage }}>
        {children}
        </FooterContext.Provider>
    );
    };

    export const useFooterData = () => {
    const context = useContext(FooterContext);
    if (!context) {
        throw new Error('useFooterData must be used within FooterProvider');
    }
    return context;
    };